export default __webpack_public_path__ + "static/media/female_05.0ff2f17d.png";